const PROJECT_ID = '2t6uyj3k';
const DATASET = 'production';

export function getImageUrlFromRef(assetRef) {
  if (!assetRef || typeof assetRef !== 'string') return null;
  // assetRef example: image-d11a5fe8ff32203b715bd7b99b0e2e1d79f7cfc9-1920x1080-png
  const extMatch = assetRef.match(/-(png|jpe?g|webp|gif)$/);
  if (extMatch) {
    const ext = extMatch[1];
    const filename = assetRef.replace(new RegExp(`-${ext}$`), `.${ext}`);
    return `https://cdn.sanity.io/images/${PROJECT_ID}/${DATASET}/${filename}`;
  }
  // fallback: append as-is
  return `https://cdn.sanity.io/images/${PROJECT_ID}/${DATASET}/${assetRef}`;
}

export function normalizePosts(rawPosts = []) {
  if (!Array.isArray(rawPosts)) return [];
  return rawPosts.map((p) => {
    const post = { ...p };
    // normalize id
    post.id = post._id || post.id || post.id === 0 ? post.id : undefined;

    // normalize slug
    if (post.slug && typeof post.slug === 'object') {
      post.slug = post.slug.current || JSON.stringify(post.slug);
    }

    // normalize coverImage
    if (post.coverImage) {
      if (typeof post.coverImage === 'string') {
        // keep as-is
      } else if (post.coverImage.asset && post.coverImage.asset._ref) {
        post.coverImage = getImageUrlFromRef(post.coverImage.asset._ref);
      } else if (post.coverImage._ref) {
        post.coverImage = getImageUrlFromRef(post.coverImage._ref);
      } else {
        post.coverImage = null;
      }
    }

    // convert Sanity Portable Text (`body`) to `content` used by the site
    if (!post.content || !Array.isArray(post.content)) {
      const body = post.body;
      if (Array.isArray(body)) {
        const content = [];

        for (const blk of body) {
          if (!blk) continue;

          // Portable Text block
          if (blk._type === 'block') {
            const style = blk.style || 'normal';
            const children = (blk.children || []).map((c) => ({ text: c.text || '', marks: Array.isArray(c.marks) ? c.marks : [] }));

            // Item de lista (bullet/número): agrupa itens consecutivos do
            // mesmo tipo em um único bloco de lista, em vez de virarem
            // parágrafos soltos sem marcador nem indentação.
            if (blk.listItem === 'bullet' || blk.listItem === 'number') {
              const listType = blk.listItem === 'number' ? 'numberList' : 'bulletList';
              const previous = content[content.length - 1];
              if (previous && previous.type === listType) {
                previous.items.push(children);
              } else {
                content.push({ type: listType, items: [children] });
              }
              continue;
            }

            if (/^h\d$/i.test(style)) {
              const level = parseInt(style.replace(/[^0-9]/g, ''), 10) || 2;
              const text = children.map((c) => c.text).join('');
              content.push({ type: 'heading', level, text });
              continue;
            }

            content.push({ type: 'paragraph', children });
            continue;
          }

          // Affiliate card block from Sanity
          if (blk._type === 'affiliateCard') {
            content.push({
              type: 'affiliateAmazonLink',
              text: blk.title || blk.text || '',
              url: blk.url || blk.link || ''
            });
            continue;
          }

          // Divider or other known types
          if (blk._type === 'divider') {
            content.push({ type: 'divider' });
            continue;
          }

          // Unknown block types: try to stringify useful fields
          if (blk.title || blk.text) {
            content.push({ type: 'paragraph', text: blk.title || blk.text });
          }
        }

        post.content = content;
      } else {
        post.content = [];
      }
    }

    return post;
  });
}
